import type { Norma, SearchHit, SearchResponse, CordobaOri, BcraDoc } from './types';

export let BASE = '/api';

if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  if (host.endsWith('.pages.dev')) {
    if (host.includes('personal')) {
      BASE = 'https://normas.pablochoi.com.ar/api';
    } else {
      BASE = 'https://normas.bcdabogados.com.ar/api';
    }
  }
}

async function jsonOrThrow<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`;
    try {
      const data = (await res.json()) as { error?: string };
      if (data.error) msg = data.error;
    } catch {}
    throw new Error(msg);
  }
  return res.json() as Promise<T>;
}

export interface SearchOptions {
  q?: string;
  tipo?: string;
  anio?: number;
  signal?: AbortSignal;
}

export const api = {
  async searchInfoleg(opts: SearchOptions): Promise<SearchResponse> {
    const params = new URLSearchParams();
    if (opts.q) params.set('q', opts.q);
    if (opts.tipo) params.set('tipo', opts.tipo);
    if (opts.anio) params.set('anio', String(opts.anio));
    params.set('limit', '20');
    const res = await fetch(`${BASE}/infoleg/search?${params}`, { signal: opts.signal });
    return jsonOrThrow<SearchResponse>(res);
  },

  async searchTheme(q: string, signal?: AbortSignal): Promise<SearchResponse> {
    const res = await fetch(`${BASE}/search/theme?q=${encodeURIComponent(q)}`, { signal });
    return jsonOrThrow<SearchResponse>(res);
  },


  async getInfoleg(id: string, fresh = false, original = false): Promise<Norma> {
    const params = new URLSearchParams();
    if (fresh) params.set('fresh', '1');
    if (original) params.set('original', '1');
    const url = `${BASE}/infoleg/norma/${encodeURIComponent(id)}?${params}`;
    const res = await fetch(url);
    return jsonOrThrow<Norma>(res);
  },

  async searchCordoba(ori: CordobaOri, numero?: string, anio?: number, signal?: AbortSignal): Promise<SearchResponse> {
    const params = new URLSearchParams({ ori });
    if (numero) params.set('numero', numero);
    if (anio) params.set('anio', String(anio));
    const res = await fetch(`${BASE}/cordoba/search?${params}`, { signal });
    return jsonOrThrow<SearchResponse>(res);
  },

  async getCordoba(ori: CordobaOri, id: string, fresh = false): Promise<Norma> {
    const params = new URLSearchParams({ ori, id });
    if (fresh) params.set('fresh', '1');
    const res = await fetch(`${BASE}/cordoba/norma?${params}`);
    return jsonOrThrow<Norma>(res);
  },

  async getInfolegVinculos(id: string, modo: 1 | 2, signal?: AbortSignal): Promise<SearchHit[]> {
    const res = await fetch(`${BASE}/infoleg/vinculos/${encodeURIComponent(id)}?modo=${modo}`, { signal });
    return jsonOrThrow<SearchHit[]>(res);
  },

  async getBcraOrdenamientos(signal?: AbortSignal): Promise<BcraDoc[]> {
    const res = await fetch(`${BASE}/bcra/ordenamientos`, { signal });
    return jsonOrThrow<BcraDoc[]>(res);
  },

  async getBcraNorma(url: string, title?: string, fresh = false): Promise<Norma> {
    const params = new URLSearchParams({ url });
    if (title) params.set('title', title);
    if (fresh) params.set('fresh', '1');
    const res = await fetch(`${BASE}/bcra/norma?${params}`);
    return jsonOrThrow<Norma>(res);
  },
};
